import React from 'react'
import { useTranslation } from 'react-i18next';

export default function LandingForm() {
    const { t, i18n } = useTranslation();
    return (
        <div className="landing-form-wrapper">
            <div className="form-heading text-center">
                <h3>Lets get started</h3>
                <p>Please complete a short form to get your personalized report</p>
            </div>
            <div className="form-inner">
                <div className="form-group mb-3">
                    <input type="text" className="form-control" placeholder="First name" />
                </div>
                <div className="form-group mb-3">
                    <input type="text" className="form-control" placeholder="Last name" />
                </div>
                <div className="form-group mb-3">
                    <input type="text" className="form-control" placeholder="Business email" />
                </div>
                <div className="form-group mb-3">
                    <select className="form-control">
                        <option>Country</option>
                        <option>India</option>
                        <option>Japan</option>
                        <option>China</option>
                        <option>USA</option>
                    </select>
                </div>
                <div className="form-group mb-3">
                    <select className="form-control">
                        <option>State</option>
                        <option>India</option>
                        <option>Japan</option>
                        <option>China</option>
                        <option>USA</option>
                    </select>
                </div>

                <div className="form-group mb-3">
                    <input type="text" className="form-control" placeholder="Enter phone number" />
                </div>
                <div className="form-group mb-3">
                    <div className="form-check d-flex ps-0">
                        <input type="checkbox" className="form-check-input" id="consent" />
                        <label className="form-check-label flex-grow-1 ps-3 m-0" htmlFor="consent">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras tempor elementum est sed imperdiet. Integer </label>
                    </div>
                </div>
                <div className="text-center button-wrap">
                    <button type="submit" className="btn btn-primary">{t('survey.builder.submit')}</button>
                </div>
            </div>
        </div>
    )
}
